import { CalendarMonth } from "@mui/icons-material";
import InfoIcon from "@mui/icons-material/Info";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { ValidationRuleVOActivityResponsabilityRetrieve, ValidationRuleVOActivityRetrieve } from "../../../model/ValidationRuleModel";
import { GetOrganizationUser, GetOrganizationUserName } from "../../../services/OrganizationServices";
import { GetEnumTerm } from "../../../services/ValidationRuleService";
import { GetWorkspaceUserPermission } from "../../../services/WorkSpaceServices";

interface ITag {
  key: string;
  name: string;
}

interface ValidationRuleActivityCompProps {
  nameOrg: string;
  validateNewEdit: ValidationRuleVOActivityRetrieve;
  returnValidation: (returnValidation: ValidationRuleVOActivityRetrieve) => void;
}

export const ValidationRuleActivity = (props: ValidationRuleActivityCompProps) => {
  const { t } = useTranslation();
  const [id, setId] = useState<number>(0);
  const [order, setOrder] = useState<number>(0);
  const [name, setName] = useState<string>("");
  const [backOperationLabel, setBackOperationLabel] = useState<string>("");
  const [forwardOperationLabel, setForwardOperationLabel] = useState<string>("");
  const [type, setType] = useState<string>("0");
  const [reloadUsers, setReloadUsers] = useState<boolean>(false);
  const [users, setUsers] = useState<ITag[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<ITag[]>([]);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const [dinamicUserChoice, setDinamicUserChoice] = useState<boolean>(false);
  const [concensualApproval, setConcensualApproval] = useState<boolean>(false);
  const [termNumber, setTermNumber] = useState<number>(props.validateNewEdit.term! ?? 1);
  const [termOptions, setTermOptions] = useState<{key: string | number, text: string}[]>([]);
  const [descriptionTerm, setDescriptionTerm] = useState<string>("");
  const [termType, setTermType] = useState<string>(props.validateNewEdit.enumTermDescription?.toString()!);
  const { nameOrg, idWorkspace } = useParams();

  useEffect(() => {
    GetEnumTerm()
      .then((result) => {
        let options = [{ key: "SE", text: "selecione" }];
        result.map((response) => {
          options.push({ key: response.index, text: response.name });
        });
        setTermOptions(options);
      })
      .catch((error) => {
        if (error.response && error.response.data && typeof error.response.data === 'string') {
          setErrorMessage(error.response.data);
        } else {
          setErrorMessage(t("ValidationRule.erroTermTypes"));
        }
      });
  }, [nameOrg, t]);

  useEffect(() => {
    console.log(termType)
  }, [termType])

  useEffect(() => {

    console.log(props.validateNewEdit)

    if (props.validateNewEdit.id !== undefined) {
      setId(props.validateNewEdit.id);
    }

    if (props.validateNewEdit.term !== undefined) {
      setTermNumber(props.validateNewEdit.term);
    }

    if (props.validateNewEdit.enumTermDescription !== undefined) {
      setDescriptionTerm(props.validateNewEdit.enumTermDescription.toString());
    }

    if (props.validateNewEdit.order !== undefined) {
      setOrder(props.validateNewEdit.order);
    }

    if (props.validateNewEdit.name !== undefined) {
      setName(props.validateNewEdit.name);
    }

    if (props.validateNewEdit.type !== undefined) {
      setType(props.validateNewEdit.type);
    }

    if (props.validateNewEdit.responsability !== undefined && props.validateNewEdit.responsability.length > 0) {
      const newUsers = props.validateNewEdit.responsability.map(item => ({ 
        key: item.idObject ? item.idObject : "", 
        name: item.nameObject ? item.nameObject : "" 
      }));
      setSelectedUsers(newUsers);
      setReloadUsers(true);
    }

    if (props.validateNewEdit.backOperationLabel !== undefined) {
      setBackOperationLabel(props.validateNewEdit.backOperationLabel);
    }

    if (props.validateNewEdit.forwardOperationLabel !== undefined) {
      setForwardOperationLabel(props.validateNewEdit.forwardOperationLabel);
    }

    if (props.validateNewEdit.dinamicUserChoice !== undefined) {
      setDinamicUserChoice(props.validateNewEdit.dinamicUserChoice);
    }

    if (props.validateNewEdit.concensualApproval !== undefined) {
      setConcensualApproval(props.validateNewEdit.concensualApproval);
    }

    if (props.validateNewEdit.term !== undefined) {
      if (props.validateNewEdit.enumTermDescription != undefined) {
        setTermType(props.validateNewEdit.enumTermDescription.toString());
      }
    }
  }, [props.validateNewEdit]);

  useEffect(() => {
    if (reloadUsers) {
      setReloadUsers(false);
    }
  }, [reloadUsers]);

  useEffect(() => {
    GetWorkspaceUserPermission(idWorkspace!)
      .then((users) => {
        const userTags: ITag[] = users.map(item => ({ key: item.userId, name: item.name }));
        setUsers(userTags);
      })
      .catch((error) => {
        console.error("Failed to load users", error);
      });
  }, [props.nameOrg]);

  const filterUsers = async (searchText: string) => {
    if (!searchText) return [];

    try {
      const filteredUsers = await GetOrganizationUserName(props.nameOrg, searchText);
      return filteredUsers.map(user => ({ key: user.id, name: user.name }));
    } catch (error) {
      console.error("Error filtering users", error);
      return [];
    }
  };

  const handleSave = () => {
    setErrorMessage(undefined);

    if (type == "1" && selectedUsers.length > 1) {
      setErrorMessage(t("ValidationRule.AssignActError"));
      return;
    }

    if (name.trim() === "") {
      setErrorMessage(t("ValidationRule.erroName"));
      return;
    }

    if (backOperationLabel.trim() === "") {
      setErrorMessage(t("ValidationRule.erroBackOperationLabel"));
      return;
    }

    if (forwardOperationLabel.trim() === "") {
      setErrorMessage(t("ValidationRule.erroForwardOperationLabel"));
      return;
    }

    if (dinamicUserChoice === false && selectedUsers.length === 0) {
      setErrorMessage(t("ValidationRule.erroItensTagUser"));
      return;
    }

    let validateReturn: ValidationRuleVOActivityRetrieve = { ...props.validateNewEdit };
    validateReturn.id = id;
    validateReturn.order = order;
    validateReturn.type = type;
    validateReturn.name = name;
    validateReturn.backOperationLabel = backOperationLabel;
    validateReturn.forwardOperationLabel = forwardOperationLabel;
    validateReturn.dinamicUserChoice = dinamicUserChoice;
    validateReturn.concensualApproval = concensualApproval;

    if (selectedUsers.length < 2 && concensualApproval) {
      setErrorMessage(t("ValidationRule.UserConcensualNotAllowed"));
      throw new Error();
    }

    if (termType === "0") {
      validateReturn.term = termNumber;
      validateReturn.enumTermDescription = 0;
    } else if (termType === "1") {
      validateReturn.term = 0;
      validateReturn.enumTermDescription = 1;
    } else if (termType === "2") {
      validateReturn.term = 0;
      validateReturn.enumTermDescription = 2;
    }

    let responsabilityList: ValidationRuleVOActivityResponsabilityRetrieve[] = selectedUsers?.map(user => ({
      idObject: user.key.toString(),
      nameObject: user.name,
      typeObject: '0'
    }));
    
    validateReturn.responsability = responsabilityList;

    console.log(validateReturn)
    
    props.returnValidation(validateReturn);
  };

  return (
    <>    
        <Typography variant="h5" component="h2" gutterBottom sx={{
          textAlign: "left",
          font: "normal normal bold 20px/30px Segoe UI",
          letterSpacing: "0px",
          color: "#2D2D2D",
          opacity: 1,
        }}>
          {t("ValidationRule.AddNewActivity")}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{
          textAlign: "left",
          font: "normal normal normal 14px/21px Segoe UI",
          letterSpacing: "0px",
          color: "#969696",
          opacity: 1,
        }}>
          {t("ValidationRule.ActivityDescriptor")}        
        </Typography>
        
        <Divider sx={{ my: 2 }} />
        
        <Box component="form" sx={{ mt: 2 }}>

        <Box sx={{ mb: 3 }}>
            <Select
              MenuProps={{
                disablePortal: true
              }}
              fullWidth
              variant="standard"
              value={type}
              onChange={e => {
                setType(e.target.value)
              }}
            >
              <MenuItem
                value="0"
              >
                {t("ValidationRule.AprovalAct")}
              </MenuItem>
              <MenuItem
                value="1"
              >
                {t("ValidationRule.AssignAct")}
              </MenuItem>
            </Select>
          </Box>

          <Box sx={{ mb: 3 }}>
            <TextField
              fullWidth
              label={
                <Typography
                  sx={{
                    textAlign: "left",
                    font: "normal normal normal 12px/18px Segoe UI",
                    letterSpacing: "0px",
                    color: "#2D2D2D",
                    opacity: 1,
                  }}
                >
                  {t("ActivityName.message")}
                </Typography>
              }
              variant="standard"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Digite aqui..."
              inputProps={{ maxLength: 100 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton size="small">
                      <InfoIcon fontSize="small" color="action" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          
          <Box sx={{ mb: 0.5 }}>
            <Typography
                  sx={{
                    textAlign: "left",
                    font: "normal normal normal 12px/18px Segoe UI",
                    letterSpacing: "0px",
                    color: "#2D2D2D",
                    opacity: 1,
                  }}
                >
              {t("Responsible.message")}
            </Typography>
              <Autocomplete
                multiple
                id="user-select"
                options={users}
                limitTags={2}
                disabled={dinamicUserChoice}
                getOptionLabel={(option) => option.name}
                value={selectedUsers}
                onChange={(_, newValue) => {
                  if (newValue != null) {
                    setSelectedUsers(newValue as ITag[])
                  }
                }}
                disablePortal={true}
                isOptionEqualToValue={(option, value) => option.key === value.key}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      label={option.name}
                      {...getTagProps({ index })}
                      key={option.key}
                      disabled={dinamicUserChoice}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    placeholder={t("ValidationRule.SelectUser")}
                    fullWidth
                  />
                )}
              />
            <FormControlLabel
              control={
                <Checkbox
                  checked={dinamicUserChoice}
                  onChange={(e) => {
                    setDinamicUserChoice(e.target.checked)
                    if(selectedUsers.length > 0){
                      setSelectedUsers([])
                    }
                    if (concensualApproval) {
                      setConcensualApproval(false);
                    }
                  }}
                  disabled={type === "1" ||  concensualApproval}
                />
              }
              label={t("ValidationRule.dinamic")}
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={concensualApproval}
                  onChange={(e) => {
                    setConcensualApproval(e.target.checked)
                    if (dinamicUserChoice) {
                      setDinamicUserChoice(false);
                    }
                  }}
                  disabled={dinamicUserChoice}
                />
              }
              label={t("ValidationRule.Consensual")}
            />
          </Box>
          
          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <TextField
              inputProps={{ maxLength: 15 }}
              label={
                <Typography
                  sx={{
                    textAlign: "left",
                    font: "normal normal normal 12px/18px Segoe UI",
                    letterSpacing: "0px",
                    color: "#2D2D2D",
                    opacity: 1,
                  }}
                >
                  {t("ValidationRule.backOperationLabel")}
                </Typography>
              }
              variant="standard"
              fullWidth
              value={backOperationLabel}
              onChange={(e) => setBackOperationLabel(e.target.value)}
              placeholder="Digite aqui..."
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton size="small">
                      <InfoIcon fontSize="small" color="action" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
            inputProps={{ maxLength: 15 }}
              label={
                <Typography
                  sx={{
                    textAlign: "left",
                    font: "normal normal normal 12px/18px Segoe UI",
                    letterSpacing: "0px",
                    color: "#2D2D2D",
                    opacity: 1,
                  }}
                >
                  {t("ValidationRule.forwardOperationLabel")}
                </Typography>
              }
              variant="standard"
              fullWidth
              value={forwardOperationLabel}
              onChange={(e) => setForwardOperationLabel(e.target.value)}
              placeholder="Digite aqui..."
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton size="small">
                      <InfoIcon fontSize="small" color="action" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          
          <Box sx={{ mb: 3 }}>
            <FormControl component="fieldset" sx={{ width: "100%" }}>
              <FormLabel component="legend" sx={{
                textAlign: "left",
                font: "normal normal bold 14px/21px Segoe UI",
                letterSpacing: "0px",
                color: "#2D2D2D",
                opacity: 1,
              }}>{t("Term.message")}</FormLabel>
              <RadioGroup
                value={termType}
                onChange={(e) => setTermType(e.target.value)}
              >
                <FormControlLabel 
                  value="2" 
                  control={<Radio />}  
                  label={
                    <Typography
                      sx={{
                        textAlign: "left",
                        font: "normal normal normal 14px/21px Segoe UI",
                        letterSpacing: "0px",
                        color: "#2D2D2D",
                        opacity: 1,
                      }}
                    >
                      {t("ValidationRule.NoTerm")}
                    </Typography>
                  }
                />
                <Divider />
                <FormControlLabel 
                  value="1" 
                  control={<Radio />} 
                  label={
                    <Typography
                      sx={{
                        textAlign: "left",
                        font: "normal normal normal 14px/21px Segoe UI",
                        letterSpacing: "0px",
                        color: "#2D2D2D",
                        opacity: 1,
                      }}
                    >
                      {t("ValidationRule.UserTerm")}
                    </Typography>
                  } 
                />
                <Divider />
                <FormControlLabel 
                  value="0" 
                  control={<Radio />} 
                  label={
                    <Typography
                      sx={{
                        textAlign: "left",
                        font: "normal normal normal 14px/21px Segoe UI",
                        letterSpacing: "0px",
                        color: "#2D2D2D",
                        opacity: 1,
                      }}
                    >
                      {t("ValidationRule.ActivityTerm")}
                    </Typography>
                  }                />
                <TextField
                  label={t("Term.days")}
                  type="number"
                  variant="standard"
                  value={termNumber}
                  disabled={termType != "0"}
                  onChange={(e) => setTermNumber(Number(e.target.value))}
                  InputProps={{
                    inputProps: { min: 1, max: 999 },
                    endAdornment: (
                      <InputAdornment position="end">
                        <CalendarMonth />
                      </InputAdornment>
                    )
                  }}
                />
              </RadioGroup>
            </FormControl>
          </Box>
          
          {errorMessage && (
            <Typography color="error" variant="body2" sx={{ mt: 2, mb: 2 }}>
              {errorMessage}
            </Typography>
          )}

          <Box>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              size="large"
              sx={{ minWidth: 120, mb: 2 }}
              fullWidth
            >
              {t("Salvar.message")}
            </Button>
          </Box>
        </Box>
    </>
  );
};
